/* eslint-disable react/no-unescaped-entities */
import { FC } from 'react';
import styled from 'styled-components';

import { MpOl } from 'shared/ui/MpOl';
import { MpParagraph } from 'shared/ui/MpParagraph';
import { MpPropertyTitle } from 'shared/ui/MpPropertyTitle';
import { MpText } from 'shared/ui/MpText';
import { MpTextbox } from 'shared/ui/MpTextbox';
import { MpUl } from 'shared/ui/MpUl';

const ImgStyled = styled.img`
	margin-top: 16px;
	margin-bottom: 12px;
	margin-left: 0;
	@media (min-width: ${props => props.theme.breakpoints.xs}) {
		width: 100%;
	}
	@media (min-width: ${props => props.theme.breakpoints.md}) {
		width: 450px;
	}
	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		width: 600px;
	}
	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		margin-left: 46px;
	}
`;

export const ListStyled = styled(MpOl)`
	gap: 12px;
	margin-bottom: 24px;
`;

export const Denvik1CZupInstruction: FC = () => (
	<section>
		<MpPropertyTitle style={{ marginBottom: `16px` }}>Установка обработки</MpPropertyTitle>
		<ListStyled>
			<li>
				<MpText>
					Оформляем подписку и&nbsp;скачиваем обработку через&nbsp;кнопку <b>Скачать приложение</b>. Файл
					сохранится на&nbsp;компьютере
				</MpText>
			</li>
			<li>
				<MpText>
					Откроем 1С и перейдём в пункт меню <b>Администрирование &rarr; Печатные формы и обработки</b>
				</MpText>
				<ImgStyled
					src='https://cdn.dodostatic.net/static/marketplace/1czup/instruction-2x-new-1'
					style={{ marginBottom: `24px` }}
				/>
				<MpText style={{ marginLeft: `-16px` }}>
					Проверяем, что стоит галочка на&nbsp;пункте <b>Дополнительные отчеты и обработки</b>. Если нет —
					установим галочку
				</MpText>
				<ImgStyled src='https://cdn.dodostatic.net/static/marketplace/1czup/instruction-2x-2' />
			</li>
			<li>
				<MpText>
					Перейдём по&nbsp;ссылке <b>Дополнительные отчеты и&nbsp;обработки</b>. В&nbsp;открывшемся списке
					выберем{` `}
					<b>Добавить из&nbsp;файла</b>
				</MpText>
				<ImgStyled
					src='https://cdn.dodostatic.net/static/marketplace/1czup/instruction-2x-3'
					style={{ marginBottom: `24px` }}
				/>
				<MpText style={{ marginLeft: `-16px` }}>
					Выйдет предупреждение безопасности — нажмём <b>Продолжить</b>
				</MpText>
				<ImgStyled
					src='https://cdn.dodostatic.net/static/marketplace/1czup/instruction-2x-4'
					style={{ marginBottom: `24px` }}
				/>
				<MpText style={{ marginLeft: `-16px` }}>Выберем сохраненный файл: «ЗагрузкаТабеляИзДодоИС.epf»</MpText>
				<ImgStyled src='https://cdn.dodostatic.net/static/marketplace/1czup/instruction-2x-5' />
			</li>
			<li>
				<MpText>
					Выбираем размещение обработки в&nbsp;разделе <b>Зарплата</b>
				</MpText>
				<ImgStyled
					src='https://cdn.dodostatic.net/static/marketplace/1czup/instruction-2x-6'
					style={{ marginBottom: `24px` }}
				/>
				<MpText style={{ marginLeft: `-16px` }}>Добавим быстрый доступ для&nbsp;пользователей обработки</MpText>
				<ImgStyled
					src='https://cdn.dodostatic.net/static/marketplace/1czup/instruction-2x-n-7'
					style={{ marginBottom: `24px` }}
				/>
				<MpText style={{ marginLeft: `-16px`, marginBottom: `8px` }}>
					Нажмём <b>Записать и закрыть</b>
				</MpText>
			</li>
			<li>
				<MpParagraph>Обработка добавлена</MpParagraph>
				<MpText style={{ marginLeft: `-16px` }}>
					Теперь обработка доступна в базе <b>Зарплата и&nbsp;управление персоналом</b> в разделе{` `}
					<b>Зарплата &rarr; Дополнительные обработки</b>. Запустить обработку можно через&nbsp;кнопку{` `}
					<b>Выполнить</b>
				</MpText>
				<ImgStyled
					src='https://cdn.dodostatic.net/static/marketplace/1czup/instruction-2x-n-8'
					style={{ marginBottom: `24px` }}
				/>
			</li>
		</ListStyled>
		<MpPropertyTitle style={{ marginBottom: `16px` }}>Работа с обработкой</MpPropertyTitle>
		<MpText>На форме обработки выведены параметры:</MpText>
		<MpUl
			style={{
				gap: `0px`,
			}}
		>
			<li>
				<MpText>Организация</MpText>
			</li>
			<li>
				<MpText>Период загрузки</MpText>
			</li>
			<li>
				<MpText>Период ввода данных о времени</MpText>
			</li>
			<li>
				<MpText>Режим поиска физических лиц</MpText>
			</li>
		</MpUl>
		<ListStyled>
			<li>
				<MpText>
					Для начала получим данные из Dodo IS через соответствующую кнопку. Если ранее еще не проходили
					авторизацию, откроется окно в&nbsp;отдельной вкладке браузера. 1С будет висеть в&nbsp;ожидании
					успешной авторизации
				</MpText>
				<ImgStyled src='https://cdn.dodostatic.net/static/marketplace/1czup/instruction-2x-n-10' />
			</li>
			<li>
				<MpText>
					После успешной авторизации выйдет таблица с выбором подразделений. Корректно сопоставим
					подразделения. Отметим галочкой те, которые хотим загружать. Далее нажмём кнопку <b>Продолжить</b>
				</MpText>
				<ImgStyled src='https://cdn.dodostatic.net/static/marketplace/1czup/instruction-2x-new-11' />
			</li>
			<li>
				<MpText>
					Следующим шагом сопоставим физические лица. Дважды нажмём на поле физического лица,
					в&nbsp;открывшемся окошке выберем соответствующее. Далее нажмём на&nbsp;кнопку <b>Продолжить</b>
				</MpText>
				<ImgStyled
					src='https://cdn.dodostatic.net/static/marketplace/1czup/instruction-2x-n-12'
					style={{ marginBottom: `24px` }}
				/>
				<MpText style={{ marginLeft: `-16px` }}>
					Если обработка не нашла физическое лицо — выберем его вручную через&nbsp;кнопку <b>(+)</b>. После
					этого в 1С:ЗУП сохраняется идентификатор физического лица из&nbsp;Dodo&nbsp;IS
				</MpText>
			</li>
			<li>
				<MpText>
					После загрузки данных с&nbsp;сервера&nbsp;Dodo IS,&nbsp;на&nbsp;вкладке <b>Служебное</b> можно
					посмотреть смены сотрудников
				</MpText>
				<ImgStyled src='https://cdn.dodostatic.net/static/marketplace/1czup/instruction-2x-n-13' />
			</li>
			<li>
				<MpText>
					На&nbsp;вкладке <b>Основное</b> нажмём на&nbsp;кнопку&nbsp;<b>Загрузить в&nbsp;документы</b>
				</MpText>
				<ImgStyled src='https://cdn.dodostatic.net/static/marketplace/1czup/instruction-2x-n-14' />
			</li>
			<li>
				<MpText>Сформируется список документов по&nbsp;выбранным подразделениям</MpText>
				<ImgStyled
					src='https://cdn.dodostatic.net/static/marketplace/1czup/instruction-2x-n-15'
					style={{ marginBottom: `24px` }}
				/>
				<MpText style={{ marginLeft: `-16px` }}>
					Дважды нажмём на поле с&nbsp;табелем. Появится кнопка, при&nbsp;нажатии на которую можно открыть
					выбранный табель
				</MpText>
				<ImgStyled
					src='https://cdn.dodostatic.net/static/marketplace/1czup/instruction-2x-n-16'
					style={{ marginBottom: `24px` }}
				/>
				<ImgStyled
					src='https://cdn.dodostatic.net/static/marketplace/1czup/instruction-2x-new-16'
					style={{ marginBottom: `24px` }}
				/>
				<MpTextbox style={{ marginLeft: `-16px` }}>
					Количество часов в табеле 1С и в Dodo IS может незначительно отличаться. Зарплатный отчёт работает с
					отрезками в&nbsp;15&nbsp;мин. Например: если смена сотрудника равна 6&nbsp;ч 17&nbsp;мин, будет
					учтён только отрезок 6&nbsp;ч 15&nbsp;мин
				</MpTextbox>
				<MpText style={{ marginLeft: `-16px` }}>
					Полный список табелей можно посмотреть во&nbsp;вкладке <b>Зарплата &rarr; Учет времени</b>
				</MpText>
				<ImgStyled src='https://cdn.dodostatic.net/static/marketplace/1czup/instruction-2x-n-18' />
			</li>
		</ListStyled>
	</section>
);

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DenvikInstruction_eng: FC = () => (
	<section>
		<MpPropertyTitle style={{ marginBottom: `16px` }}>Installation of Processing</MpPropertyTitle>
		<ListStyled>
			<li>
				<MpText>
					Subscribe, and then download the processing using the "Download File" button. The file will be saved
					on your computer.
				</MpText>
			</li>
			<li>
				<MpText>Open 1C and go to the "Administration" menu - "Printed Forms and Processing."</MpText>
				<ImgStyled src='https://cdn.dodostatic.net/static/marketplace/denvik/instruction-1' />
			</li>
			<li>
				<MpText>
					Check that the checkbox is selected for "Additional Reports and Processing." If not, select it.
					Then, follow the link "Additional Reports and Processing."
				</MpText>
				<ImgStyled src='https://cdn.dodostatic.net/static/marketplace/denvik/instruction-2' />
			</li>
			<li>
				<MpText>Click "Add from File" in the opened list.</MpText>
				<ImgStyled src='https://cdn.dodostatic.net/static/marketplace/denvik/instruction-3' />
			</li>
			<li>
				<MpText>There will be a security warning - click "Continue."</MpText>
				<ImgStyled src='https://cdn.dodostatic.net/static/marketplace/denvik/instruction-4' />
			</li>
			<li>
				<MpText>Select the saved exchange file: DodoIs_DataUpload_Ready.epf.</MpText>
				<ImgStyled src='https://cdn.dodostatic.net/static/marketplace/denvik/instruction-5' />
			</li>
			<li>
				<MpText>
					Choose where in the menu you want to invoke this processing; specify the location, for example,
					sales.
				</MpText>
				<ImgStyled src='https://cdn.dodostatic.net/static/marketplace/denvik/instruction-6' />
			</li>
			<li>
				<MpText>
					Then specify which user is allowed to use the processing. Go to "Quick Access," move the necessary
					users to the right side of the list in the opened window, and click "OK."
				</MpText>
				<ImgStyled src='https://cdn.dodostatic.net/static/marketplace/denvik/instruction-7' />
			</li>
			<li>
				<MpText>The processing is added. Click "Save and Close."</MpText>
				<ImgStyled src='https://cdn.dodostatic.net/static/marketplace/denvik/instruction-8' />
			</li>
		</ListStyled>
		<MpPropertyTitle style={{ marginBottom: `16px` }}>Processing Configuration</MpPropertyTitle>
		<ListStyled>
			<li>
				<MpText>
					The exchange processing will be available from the "Sales" menu - "Additional Processes."
				</MpText>
				<ImgStyled src='https://cdn.dodostatic.net/static/marketplace/denvik/instruction-9' />
			</li>
			<li>
				<MpText>Select the processing "Data Upload (Dodo IS)" and click "Run."</MpText>
				<ImgStyled src='https://cdn.dodostatic.net/static/marketplace/denvik/instruction-10-new' />
			</li>
			<li>
				<MpText>
					In the "Organization" field, select your organization. Then click the "Settings" button.
				</MpText>
			</li>
			<li>
				<MpText>
					When you first open the processing, it will ask you to specify general settings. We recommend using
					the "Fill in all default settings at once" button.
				</MpText>
				<ImgStyled src='https://cdn.dodostatic.net/static/marketplace/denvik/instruction-11' />
			</li>
			<li>
				<MpText>
					Then click "Get." In the opened window, log in to Dodo IS. After authorization, all data will be
					pulled from Dodo IS.
				</MpText>
				<ImgStyled src='https://cdn.dodostatic.net/static/marketplace/denvik/instruction-12-new' />
			</li>
		</ListStyled>
		<MpPropertyTitle style={{ marginBottom: `16px` }}>Schedule Configuration</MpPropertyTitle>
		<ListStyled>
			<li>
				<MpText>
					If daily automatic exchange is required, you also need to add another processing to external
					processes: "Administration" - "Additional Reports and Processing" - "Add from File" and select the
					file "Exchange_DodoIS_Scheduled.epf."
				</MpText>
				<ImgStyled src='https://cdn.dodostatic.net/static/marketplace/denvik/instruction-12' />
			</li>
			<li>
				<MpText>
					In the "Run command on schedule" column, check the box. Then, a window with the launch schedule will
					open.
				</MpText>
				<ImgStyled src='https://cdn.dodostatic.net/static/marketplace/denvik/instruction-13' />
			</li>
			<li>
				<MpText>On the "General" tab, specify "Repeat every 1 day."</MpText>
				<ImgStyled
					src='https://cdn.dodostatic.net/static/marketplace/denvik/instruction-14'
					style={{ marginBottom: `24px` }}
				/>
				<MpText>
					On the second tab, specify the processing launch time. For example, the time is 8:00 AM and 4:00 PM.
					Thus, the exchange will run twice a day, loading data from the previous day.
				</MpText>
				<ImgStyled
					src='https://cdn.dodostatic.net/static/marketplace/denvik/instruction-15'
					style={{ marginBottom: `24px` }}
				/>
				<MpText>
					We recommend specifying the exchange twice a day (morning and evening). Documents will not be
					duplicated. For file-based databases, keep the 1C database open.
				</MpText>
			</li>
		</ListStyled>
	</section>
);
